import type { AddressCoordinates } from '@payaca/helpers/locationHelper';

const STATIC_MAP_ENDPOINT = 'https://maps.googleapis.com/maps/api/staticmap';

const ZOOM = 18;

export type StaticMapSize = {
  width: number;
  height: number;
};

/** 16:9, matching the thumbnail frame so Google's attribution is never cropped. */
export const DEFAULT_STATIC_MAP_SIZE: StaticMapSize = {
  width: 480,
  height: 270,
};

export const getStaticMapUrl = (
  { latitude, longitude }: AddressCoordinates,
  size = DEFAULT_STATIC_MAP_SIZE
): string | undefined => {
  const key = import.meta.env.VITE_GOOGLE_MAPS_KEY;
  if (!key) return undefined;

  const centre = `${latitude},${longitude}`;
  const params = new URLSearchParams({
    center: centre,
    zoom: String(ZOOM),
    size: `${size.width}x${size.height}`,
    scale: '2',
    maptype: 'hybrid',
    key,
  });

  return `${STATIC_MAP_ENDPOINT}?${params.toString()}`;
};
